import React from 'react'
import styled, { keyframes } from 'styled-components';

const NewTimeline = () => {

// Animations
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideIn = keyframes`
  from {
    transform: translateX(-30px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
`;

// Styled Components
const Container = styled.div`
  min-height: 100vh;
  background-color: #091B2A;
  font-family: 'Inter', sans-serif;
`;

const Title = styled.h1`
  color: white;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  animation: ${fadeIn} 1s ease-out;
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 4px;
    background: #00A1E6;
    border-radius: 2px;
  }
`;

const TimelineWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  display:flex;
  align-items:center;
  justify-content:center;
  flex-wrap:wrap;
`;

const ExperienceCard = styled.div`
  background: white;
  width:450px;
  height:100%;
  border-radius: 16px;
  padding: 2rem;
  margin:20px;
  margin-bottom: 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  animation: ${slideIn} 0.6s ease-out;
  animation-delay: ${props => props.$index * 0.2}s;
  opacity: 0;
  animation-fill-mode: forwards;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 30px rgba(0, 161, 230, 0.2);
  }

  @media (max-width: 768px) {
    width:100%;
  height:100%;
  padding:1rem;
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;

  @media (max-width:768px){
    margin-bottom: 20px;
  }
`;

const CompanyInfo = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;
`;

const LogoContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const CompanyDetails = styled.div`
  flex-grow: 1;
`;

const CompanyName = styled.h2`
  color: #091B2A;
  font-size: 1.5rem;
  margin: 0;
  font-weight: 700;

  @media (max-width:768px){
    font-size:20px;
  }
`;

const JobRole = styled.h3`
  color: #00A1E6;
  font-size: 1.1rem;
  margin: 0.5rem 0;
  font-weight: 600;

  @media (max-width:768px){
    font-size:18px;
    margin:0px 0px;
  }
`;

const Year = styled.span`
  background: #091B2A;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.9rem;
`;

const SkillsSection = styled.div`
  margin-top: 1.5rem;


  @media (max-width:768px){
    margin-top: 10px;
  }
`;

const SkillsTitle = styled.h4`
  color: #091B2A;
  font-size: 0.9rem;
  margin-bottom: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const SkillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const Skill = styled.span`
  background: #00A1E6;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  transition: transform 0.2s ease;
  
  &:hover {
    animation: ${pulse} 0.6s ease-in-out;
    transform: scale(1.05);
  }
`;


const experiences = [
    {
      year: "NOW",
      companyName: "100xWeb",
      logo: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDR0PDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT05MTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQ0NGg8PGjclHyUwNzc3Nzc3Nzc3Nzc3Nzc3Nzc3ODg3Kyw1Nzc3NzM3NzcyKzgtKzcxNy0tNys3KzI3N//AABEIABwAHAMBEQACEQEDEQH/xAAXAAADAQAAAAAAAAAAAAAAAAADBAUG/8QAKhAAAQIEBAMJAAAAAAAAAAAAAgEDAAQFERITIjEhUXEGM0FygZGhscH/xAAZAQADAQEBAAAAAAAAAAAAAAACAwQFAQb/xAAmEQACAgECBAcBAAAAAAAAAAAAAQIRAwQhEjGh0RQyQVFigcEF/9oADAMBAAIRAxEAPwCu87aPMpHuoQFCmERd4Oh6xhGn7rvHGgJQHAd0wtoncdw1LpYVTPxPG2rZCmkUW+JC47+GH2i3TYFku3yE6rWS03DUbu+ldzR0umt06mVEFFJgpYicaIwS6rl7fvqkaGPEoQa512MrPqpajNjfl4qT3+XP8+iPK9lWVBhUnHSzUEkwtXsJCRIq28vynSEeDi63Lcn9iaclwLa/X2dEYVsluUZjW5p89wcy1i3S8dTDhIaplbnKXLBLSrTGWLiuLiFdSqOHjx5fUVY9RKEaQjPocOebnNu6rrZLZlgRe7G3SJm0WznZRANMA2SuW4V0UgULi2LEA32g7HJsI2A8o42DJsaAUwwAhs//2Q==",
      jobRole: "Content Creator & Devloper",
      skills: ["React", "TypeScript", "Next.js", "SEO", "TAilwind", "GSAP"]
    },
    {
        year: "NOW",
        companyName: "American HCA",
        logo: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc1Nzc3NzctNzY1NzU1Nzc1Ly03Nf/AABEIABwAHAMBEQACEQEDEQH/xAAZAAEAAwEBAAAAAAAAAAAAAAAGAwQFBwL/xAAsEAACAgEDAgQEBwAAAAAAAAABAwIEEQAFEiFBEzFhkRQiMlEGNEJxgbHw/8QAGgEAAgMBAQAAAAAAAAAAAAAABAUBAgMABv/EACwRAAEEAAUCAgsAAAAAAAAAAAEAAgMRBBIhMVETQWFxFCIjMjNSgZGxwdH/2gAMAwEAAhEDEQA/AOsWn2tyuso7fY+GUn8xZiAZ5P6Fg9AfvIg48gCc8ZBaDR34VDbjQWVPZ6jbNtMNsZdNeYjN9ncGczIxEumc4+oeWNR132QAiRg4Qxrnu97Xa+5HPgvCU7lte3V932Ntm3SmqLm7XaaWy4EZPhTPUSA7EkH01ox7ZAMwq+6Hmhdh5HNBuiR9ko2+7X3Gii7TYGIfAThL7g6oQWmiua4OFhEtscyNrwzeZTiyWWThGJMj17yBAzI58tI4cWPSX5zQJ/GgVsPIyO87b87/AEQlG30BUFiRsusTsTE5sbxzniIj6QB5RGnDW133W0s3Uy6AAcXzfcnlZsqjtpVRXX3O0xMHKSFMCiOGcYyIA+XrqmUtqiieq2cvLowDRN67780ofw2Z7ezeKS0y+HTuLCkcegjOMGED05TloqSjRPCVMttjxVLda4pXmQcoySyRmsg4Iz54P+7a8tioujKQ4WDqFzhRU23WWJ6UnzbAD5qrR82O/Hsf49ta4aZzPhOsfKd/opaa2WYmumtWpGNaqhq1QEZqTHxWSAwZcsZ6nPXPvqs2IdYymh2rc+P8RuKx00sj6ecpJoWdvJLtnqsTTBtcpOZIzlzOSPT2GmuDhcyL2m51QrRpqrdqsm2oqsLE4/1+2iZYmStyvFhSRaM3duVTtR8BjQQcg5GQfbSObCMif6pKyIopDWpojM2PDiXT6mZGSOnb7acRwxh2etStQBureiFK/9k=",
        jobRole: "Frontend Developer",
        skills: ["React", "TypeScript", "Next.js","Wordpress", "ACF", "SEO", "KEKA", "JIRA", "TAilwind"]
      },
    {
        year: "2024",
        companyName: "American HCA",
        logo: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc1Nzc3NzctNzY1NzU1Nzc1Ly03Nf/AABEIABwAHAMBEQACEQEDEQH/xAAZAAEAAwEBAAAAAAAAAAAAAAAGAwQFBwL/xAAsEAACAgEDAgQEBwAAAAAAAAABAwIEEQAFEiFBEzFhkRQiMlEGNEJxgbHw/8QAGgEAAgMBAQAAAAAAAAAAAAAABAUBAgMABv/EACwRAAEEAAUCAgsAAAAAAAAAAAEAAgMRBBIhMVETQWFxFCIjMjNSgZGxwdH/2gAMAwEAAhEDEQA/AOsWn2tyuso7fY+GUn8xZiAZ5P6Fg9AfvIg48gCc8ZBaDR34VDbjQWVPZ6jbNtMNsZdNeYjN9ncGczIxEumc4+oeWNR132QAiRg4Qxrnu97Xa+5HPgvCU7lte3V932Ntm3SmqLm7XaaWy4EZPhTPUSA7EkH01ox7ZAMwq+6Hmhdh5HNBuiR9ko2+7X3Gii7TYGIfAThL7g6oQWmiua4OFhEtscyNrwzeZTiyWWThGJMj17yBAzI58tI4cWPSX5zQJ/GgVsPIyO87b87/AEQlG30BUFiRsusTsTE5sbxzniIj6QB5RGnDW133W0s3Uy6AAcXzfcnlZsqjtpVRXX3O0xMHKSFMCiOGcYyIA+XrqmUtqiieq2cvLowDRN67780ofw2Z7ezeKS0y+HTuLCkcegjOMGED05TloqSjRPCVMttjxVLda4pXmQcoySyRmsg4Iz54P+7a8tioujKQ4WDqFzhRU23WWJ6UnzbAD5qrR82O/Hsf49ta4aZzPhOsfKd/opaa2WYmumtWpGNaqhq1QEZqTHxWSAwZcsZ6nPXPvqs2IdYymh2rc+P8RuKx00sj6ecpJoWdvJLtnqsTTBtcpOZIzlzOSPT2GmuDhcyL2m51QrRpqrdqsm2oqsLE4/1+2iZYmStyvFhSRaM3duVTtR8BjQQcg5GQfbSObCMif6pKyIopDWpojM2PDiXT6mZGSOnb7acRwxh2etStQBureiFK/9k=",
        jobRole: "Frontend Intern",
        skills: ["React", "TypeScript", "Next.js", "Styled Components", "Wordpress", "ACF" ]
      },
    {
      year: "2023",
      companyName: "Digital Ipsum",
      logo: "https://assets.static-upwork.com/org-logo/1551996334567325696?date=1734774960756",
      jobRole: "Frontend Developer intern",
      skills: ["React", "JavaScript", "wordpress","Elmentor", "CSS", "Redux"]
    },
    {
      year: "2024",
      companyName: "MCA",
      logo: "https://content.jdmagicbox.com/comp/raipur-chhattisgarh/b5/9999px771.x771.110224230145.b2b5/catalogue/rungta-college-tatibandh-raipur-chhattisgarh-colleges-m8e3bvsd55.jpg",
      jobRole: "Rungta College of Eng BHilai",
      skills: ["Score: 74%"]
    },
    {
      year: "2023",
      companyName: "BSc (Cs)",
      logo: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIADgAOAMBIgACEQEDEQH/xAAbAAACAgMBAAAAAAAAAAAAAAAABgQFAQMHAv/EADEQAAEDAgQEBAUEAwAAAAAAAAECAwQAEQUSITEGE0FhFCJRcQcjMoGRQlKhohUXwf/EABoBAAIDAQEAAAAAAAAAAAAAAAQFAAEDAgb/xAApEQABAwIFAgYDAAAAAAAAAAABAAIDBBESEyHh8DFRBUFxwdHxIiNh/9oADAMBAAIRAxEAPwDuNeVKCSASATt3rJIG9L+NTrB+E+eS+kB2M6NlW1A7HQis5JBG25WkcZkdYKfMxNLUaWtP1xVpC0n0Nj/INeF4o2iZJSVAttRkvX9d/wDlqTsXmT3W35UZtBdWgIdaWrKly3fpsKpmuImVQJEuTzo6mflPRnB8zS1kgfq1y2t6ilh8RxH9evDsjxSRtFnmx+t11CLPDiIaFWLz7XMIHQWFz+SKmpUFXykGxtpXNcExjEVpMtyOWXXGA0whf1Np036X026U44NMSpTcKL8xDCLvvnYqPQetzc3oqCrbIcPnzdYT0paMTenNh/Vd0VgEHbWs0ag1AxaTHYjkTEOFheilpTcJ97aj3pNlvLeeDJlmQ20fkuKGtj0J3psxg4ghpS4vhnGreZt1Otve9jSQHQhK1hJJAJCEjfsKS+KyOAwt801ogGxl/NlqxJbjj8VlteRxblzl2KB9V6ixm8K4qwiTiHPVGRCecyutZc1kgELNx1tcdtK0P4fNxaK8ht5EaZPbLTaTcqS3pmtcjU6jpv0qHhvAb7DpalOvpaKRmzIyJWPS165o6MCMEc7oKWoOKw6K4waS+XHUyFpcc8qkrQnyEKSLEegOtXMF8JUGVy1MQyc7qkghTna41qonQhh+Hw3W0FMeM9yDzdVNJvoq/sLX9CPYzM1nmlIQl05hZJ1T99aFnjNNUBwFgdEdSvzW2KfcOkNSI4XGbWhkCyMyctx2HpRWrC/HloLnKYFx5UNJ2+96K9Gw3aLpZIAHEBVnEicNF/ECQt+2iWlHT3voKTJbBkRXG0OhIzArKwSAAb3B0sRvem3HeKG2EliFcOFRSp1dkhNtDa+9InEDTuKYXKhxp6WDIGRx5VleQ6qG+5216E0oq4syZpb356plC61OQ7nwlqPxO5P4kVieGhT7cdVmkKSSA2nqffU/eulJxx/EcFD0lsJWc1iBobdR9wa5lC4H8NzGm8bW226POGwAVC2x82op4wxyPBwtmG6tMgMp5YdcICiOgNlCj2OYzRp0SowyHWysW3PEypkZ9Sg29HJzftISmxH3qshCQloMTk5SysoGW13Ei2tT/wDKsBxK1Mxg4lBbHYHQj6q0qnN81DrLvLWglQKCLDr6+9C1rRKwBuuqMomujk/LonDh0Ydy7w+cly3mQ6o3/G34oqsZ4tLsRpACRLLqU6FJStN9SNdKKLjlYxoHsuZY3ueT73UZPCBxguvTnFsKRIdShPKIzJKgb766j+K9L+HcZV7znPNvZB1/t3oorZsTQLLEyuus/wCvY1iBNUAQQbN73tf9XYVg/DuIULR4w5VkE/K7W/d3ooq8tvCVM1yB8OogN/GKOh3bJv8A2rwn4bwkqzJlqB6nIfW/7vWiipgHCVWY5SInAMaNLRITMVmSoE2a77b6UUUVWUw9QpmO7r//2Q==",
      jobRole: "loyola college kunkuri",
      skills: ["Score: 81%"]
    },
    {
      year: "2019",
      companyName: "Higher secondary",
      logo: "https://davcmc.net.in/images/2022/logo.png",
      jobRole: "DAV public School kansabel",
      skills: ["Score: 67%"]
    },
    {
      year: "2017",
      companyName: "High school",
      logo: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIACAAIAMBIgACEQEDEQH/xAAYAAEBAAMAAAAAAAAAAAAAAAAFBgMEB//EAC8QAAEDAgUCAwcFAAAAAAAAAAECAxEEBRITITFBAFEGImEUMpGhsdHwFUJScYH/xAAYAQACAwAAAAAAAAAAAAAAAAACBAEDBf/EACIRAAEDAwQDAQAAAAAAAAAAAAEAAhEDEiEEIjFREzJxBf/aAAwDAQACEQMRAD8A6XeK91m5qaVVOtNylCcv+SsIHHc9FOX5ScEVtQkrS5GY4kQpMYREa4pBEHYjv1vXum9quzzeU0sFHmDpIBEJHH+9H3Am20T6i1Rt5icJSyCFuEyBxrz8D0q/9HTU6nhc7d8KE0z75hY67xC/Q0zb9TXuNhwaEmE4omJ4n8nYr2avqnbjTocqHFtuSSF7xhUft8Opi4NNVdvQ2/UstNJWhQwvDFiTqE+6dZ4AnpnwxU+13CkfKUpKpISFSUjCv3hx0TL78lWkbZhPX+2v1TZqbevLrUtlAJGiknj+wdR8/SSp7Yahqorq6oWuobROXJCm1JBACtpPG3fUyZqrzdrjTqybbaX33ArzOKT5IgHSDqTMcRBniTapFbcGy5VW8tPlEFTTawpUkDCSDtE79vXpTW6IVzdTMO7jkdKLBgu4U1kMOlsuUzbzqwkAZYUpWwgd+32/baeFrH+lsqfebQiodEFDYAS2O2m59fp0bbGKu3tLdZtgFSAnDjbWsnggK4AHy06VtFTfqtwuV1NS01OFAYVJVmKEakakDWBrvrtAnTuBxCBlMgEkr//Z",
      jobRole: "loyola English medium school",
      skills: ["Score: 65%"]
    },
  ];


  return (
    <Container>
    <Title>Professional Experience</Title>
    <TimelineWrapper>
      {experiences.map((exp, index) => (
        <ExperienceCard key={index} $index={index}>
          <CardHeader>
            <CompanyInfo>
              <LogoContainer>
                <img src={exp.logo} alt={`${exp.companyName} logo`} />
              </LogoContainer>
              <CompanyDetails>
                <CompanyName>{exp.companyName}</CompanyName>
                <JobRole>{exp.jobRole}</JobRole>
              </CompanyDetails>
            </CompanyInfo>
            <Year>{exp.year}</Year>
          </CardHeader>
          
          <SkillsSection>
            <SkillsTitle>Skills & Technologies</SkillsTitle>
            <SkillsContainer>
              {exp.skills.map((skill, skillIndex) => (
                <Skill key={skillIndex}>{skill}</Skill>
              ))}
            </SkillsContainer>
          </SkillsSection>
        </ExperienceCard>
      ))}
    </TimelineWrapper>
  </Container>
);
};
 

export default NewTimeline







